<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户名称" prop="nickname" >
        <a-input readOnly v-model="form.nickname" placeholder="请输入用户ID ｛user.id｝" />
      </a-form-model-item>
      <a-form-model-item label="商品名称" prop="goodsName" >
        <a-input readOnly v-model="form.goodsName" placeholder="请输入内容"/>
      </a-form-model-item>
      <a-form-model-item label="商品图片" prop="image" >
        <img v-viewer  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="form.image"
             :src="form.image" preview="头像"/>
      </a-form-model-item>
      <a-form-model-item label="花费果实数" prop="fruitNum" >
        <a-input readOnly v-model="form.fruitNum" placeholder="请输入花费果实数" />
      </a-form-model-item>
      <a-form-model-item label="兑换数量" prop="quantity" >
        <a-input readOnly v-model="form.quantity" placeholder="请输入兑换数量" />
      </a-form-model-item>
      <a-form-model-item label="收货人" prop="receiver" >
        <a-input readOnly  v-model="form.receiver" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="收货地址" prop="address" >
        <a-input readOnly v-model="form.address" />
      </a-form-model-item>
      <a-form-model-item label="物流单号" prop="logisticsNumber" >
        <a-input :readonly="isInfo == 0" v-model="form.logisticsNumber" placeholder="请输入物流单号" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button v-if="isInfo == 0" type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getFruitExchange, addFruitExchange, updateFruitExchange } from '@/api/user/fruitExchange'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      isInfo:0,
      // 表单参数
      form: {
        id: null,

        status: 0,

        userId: null,

        goodsId: null,

        goodsName: null,

        image: null,

        fruitNum: null,

        quantity: null,

        receiver: null,

        sex: null,

        mobile: null,

        provinceId: null,

        provinceName: null,

        cityId: null,

        cityName: null,

        areaId: null,

        areaName: null,

        address: null,

        logisticsNumber: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        status: [
          { required: true, message: '状态 0-待发货 1-待签收 2-已完成不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID ｛user.id｝不能为空', trigger: 'blur' }
        ],
        goodsId: [
          { required: true, message: '商品ID {goods.id}不能为空', trigger: 'blur' }
        ],
        goodsName: [
          { required: true, message: '商品名称不能为空', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '商品图片不能为空', trigger: 'blur' }
        ],
        fruitNum: [
          { required: true, message: '花费果实数不能为空', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: '兑换数量不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.isInfo = 0
      this.formType = 1
      this.form = {
        id: null,
        status: 0,
        userId: null,
        goodsId: null,
        goodsName: null,
        image: null,
        fruitNum: null,
        quantity: null,
        receiver: null,
        sex: null,
        mobile: null,
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null,
        areaId: null,
        areaName: null,
        address: null,
        logisticsNumber: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getFruitExchange({"id":id}).then(response => {
        this.form = response.data
        this.isInfo = 1
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateFruitExchange({id:this.form.id,logisticsNumber:this.form.logisticsNumber}).then(response => {
              this.$message.success(
                '操作成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addFruitExchange(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
